class BannerText {
	constructor() {
		this.bannerLev1 = document.querySelector(".banner-level-1");
		this.bannerLev2 = document.querySelector(".banner-level-2");
		this.bannerLev3 = document.querySelector(".banner-level-3");

		if (this.bannerLev1) {
			this.buildBannerLev1();
		}

		if (this.bannerLev2) {
			this.BuildBannerLevl2Contrast();
			this.buildBannerLev2();

			window.addEventListener("resize", () => {
				this.BuildBannerLevl2Contrast();
			});
		}

		if (this.bannerLev3) {
			this.buildBannerLev3();
		}
	}

	buildBannerLev1() {
		const title = this.bannerLev1.querySelector(".banner-title");
		this.splitTimeline(title, 0.2);
	}

	buildBannerLev2() {
		const titles = this.bannerLev2.querySelectorAll(".banner-title, .banner-contrast");
		titles.forEach(title => {
			this.splitTimeline(title, 1.25);
		});

	}

	BuildBannerLevl2Contrast() {
		const original = document.querySelector(".banner-level-2 .banner-title");
		const copy = document.querySelector(".banner-level-2 .banner-contrast");

		gsap.set(copy, {
			width: original.offsetWidth + "px",
			top: original.offsetTop + "px",
			left: original.offsetLeft + "px"
		});
	}

	buildBannerLev3() {
		const title = this.bannerLev3.querySelector(".banner-title");
		this.splitTimeline(title, 1.1);
	}

	splitTimeline(elem, delay = 0.2) {
		let splitTitle = new SplitText(elem, {
			type: "chars, words, lines",
			wordsClass: "words"
		});
		let tl = gsap.timeline({
			defaults: {duration: 1, ease: "power1.inOut"}
		});

		tl.to(elem, {autoAlpha: 1}, 0)
			.fromTo(
				splitTitle.chars, {
					autoAlpha: 0,
					yPercent: 100
				}, {
					autoAlpha: 1,
					yPercent: 0,
					ease: "power2",
					stagger: {
						each: 0.02,
						from: "random"
					}
				}, delay);
	}
}